import React from "react";
import { Button, Dialog, DialogTitle, Typography } from "@material-ui/core";
import { getServerUri } from "../modules/uriUtility";
import { makeStyles } from "@material-ui/core/styles";
import { buildDeleteConfirmMessage } from "./DialogDeleteShell";
import _ from "lodash";

const useClasses = makeStyles({
  dialogFont: {
    margin: 10,
  },
});
/**
 *
 * @param {Boolean} props.isOpen is it open?
 * @param {Function} props.setIsOpen set is open to true or false
 * @param props.fontToDelete
 * @param props.selectedFontID
 * @param props.fonts
 * @param props.setFonts
 * @param props.createSnackbar
 * @param props.selectFont
 * @param props.deleteFontFromFonts
 * @returns {JSX.Element}
 */
export default function dialogFontDelete(props) {
  const classes = useClasses();
  const file = _.get(props, "fontToDelete.file", "");
  const ext = file.includes(".") ? file.substring(file.lastIndexOf(".")) : "";
  const baseName = _.get(props, "fontToDelete.fontFamily") || file;
  const assetName = baseName && !String(baseName).includes(".") && ext ? baseName + ext : baseName;

  return (
    <Dialog
      open={props.isOpen}
      onClose={() => {
        props.setIsOpen(false);
      }}
    >
      <DialogTitle>Delete asset?</DialogTitle>
      <div className={classes.dialogFont}>
        <Typography style={{ color: "#ddd", fontSize: "13px", marginBottom: "12px" }}>
          {buildDeleteConfirmMessage(assetName)}
        </Typography>
        <Button
          variant="contained"
          style={{ backgroundColor: "#CC736E", color: "#fce4ec" }}
          onClick={() => {
            fetch(getServerUri("font/deleteOne"), {
              method: "DELETE",
              headers: {
                "content-type": "application/x-www-form-urlencoded",
              },
              body: new URLSearchParams({
                accessToken: localStorage.getItem("session.accessToken"),
                fontID: props.fontToDelete._id,
                fileName: _.get(props.fontToDelete, "file"),
              }),
            })
              .then((response) => {
                if (response.status === 200) {
                  let newFonts = _.cloneDeep(props.fonts);
                  newFonts.splice(
                    newFonts.indexOf(newFonts.filter((font) => font._id === props.fontToDelete._id)[0]),
                    1
                  );
                  props.deleteFontFromFonts(props.fontToDelete._id);
                  props.setFonts(newFonts);
                  if (newFonts.length > 0) {
                    if (props.fontToDelete._id === props.selectedFontID) {
                      props.selectFont(newFonts[0]._id);
                    }
                  } else {
                    props.selectFont("");
                  }
                  props.createSnackbar("Font deleted", "success");
                  props.onAfterDelete?.();
                  props.setIsOpen(false);
                } else {
                  response
                    .text()
                    .then((responseText) => {
                      console.log(responseText);
                    })
                    .catch(console.error);
                }
              })
              .catch((err) => {
                console.error(err);
                props.createSnackbar("An error occurred deleting the font.", "error");
              });
          }}
        >
          DELETE
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: "#555", color: "#eee", marginLeft: "8px" }}
          onClick={() => {
            props.setIsOpen(false);
          }}
        >
          Cancel
        </Button>
      </div>
    </Dialog>
  );
}
